/* Color Precision blog widgets — progressively enhances .cp-embed marker divs.
   Each marker holds plain <img> tags so content still shows if JS fails. */
(function () {
  'use strict';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function kids(node, sel) { return Array.prototype.slice.call(node.querySelectorAll(sel)); }

  /* ----- Crossfade: keep the underneath image fully opaque, fade only the top layer out ----- */
  function initCrossfade(box) {
    var imgs = kids(box, ':scope > img');
    if (imgs.length < 2) { box.classList.add('cp-ready'); return; }
    var stage = el('div', 'cp-cf');
    imgs.forEach(function (im) { stage.appendChild(im); });
    box.innerHTML = '';
    box.appendChild(stage);
    box.classList.add('cp-ready');
    imgs.forEach(function (im, idx) { im.style.opacity = '1'; im.style.zIndex = idx === 0 ? '2' : '1'; });
    var i = 0;
    var dur = 1000;
    var interval = parseInt(box.getAttribute('data-interval'), 10) || 3000;
    setInterval(function () {
      var cur = imgs[i];
      var nextI = (i + 1) % imgs.length;
      var nxt = imgs[nextI];
      nxt.style.opacity = '1'; nxt.style.zIndex = '1';  // opaque, just beneath current
      cur.style.zIndex = '2';
      cur.style.opacity = '0';                          // fade current out -> reveals next, no white
      setTimeout(function () {
        cur.style.zIndex = '0'; cur.style.opacity = '1';
        nxt.style.zIndex = '2';
        i = nextI;
      }, dur);
    }, interval);
  }

  /* ----- One carousel from an array of imgs (caption below image).
           opts.fade = crossfade between slides instead of horizontal slide. ----- */
  function buildCarousel(imgs, opts) {
    opts = opts || {};
    var fade = !!opts.fade;
    var caps = imgs.map(function (im) { return im.getAttribute('data-caption') || im.getAttribute('alt') || ''; });
    var hasCaps = caps.some(function (c) { return c; });
    var car = el('div', 'cp-car' + (fade ? ' cp-car--fade' : ''));
    var track = el('div', 'cp-car__track');
    var slides = imgs.map(function (im) {
      im.loading = 'eager';                 // preload so switching never shows a grey box
      var slide = el('div', 'cp-car__slide');
      slide.appendChild(im);
      track.appendChild(slide);
      return slide;
    });
    car.appendChild(track);
    // Single caption element (avoids stacked/double-layered captions in fade mode)
    var capEl = hasCaps ? el('div', 'cp-car__cap', caps[0]) : null;
    var dots = null;
    if (imgs.length > 1) {
      var prev = el('button', 'cp-car__arrow cp-car__arrow--prev', '‹');
      var next = el('button', 'cp-car__arrow cp-car__arrow--next', '›');
      dots = el('div', 'cp-car__dots');
      var dotEls = imgs.map(function (_, di) {
        var d = el('button', 'cp-car__dot' + (di === 0 ? ' is-active' : ''));
        dots.appendChild(d);
        return d;
      });
      car.appendChild(prev); car.appendChild(next);
      var i = 0;
      if (fade) {
        slides.forEach(function (s, k) { s.style.opacity = k === 0 ? '1' : '0'; s.style.zIndex = k === 0 ? '2' : '1'; });
      }
      function go(n) {
        var t = (n + imgs.length) % imgs.length;
        if (t === i && fade) { return; }
        if (fade) {
          // Only the OUTGOING slide stays visible beneath the incoming one.
          // (Leaving all others opaque made the wrong image show through once
          //  every slide had been viewed.)
          var prev = slides[i], nx = slides[t];
          slides.forEach(function (s, k) {
            if (k !== t && k !== i) { s.style.opacity = '0'; s.style.zIndex = '0'; }
          });
          prev.style.opacity = '1'; prev.style.zIndex = '1';
          nx.style.transition = 'none';
          nx.style.opacity = '0';
          nx.style.zIndex = '2';
          void nx.offsetWidth;            // commit the transparent state instantly
          nx.style.transition = '';
          nx.style.opacity = '1';         // fade in over the single opaque slide
        } else {
          track.style.transform = 'translateX(' + (-t * 100) + '%)';
        }
        i = t;
        if (capEl) capEl.textContent = caps[i];
        dotEls.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      prev.addEventListener('click', function () { go(i - 1); });
      next.addEventListener('click', function () { go(i + 1); });
      dotEls.forEach(function (d, di) { d.addEventListener('click', function () { go(di); }); });
    }
    var wrap = el('div');
    wrap.appendChild(car);
    if (capEl) wrap.appendChild(capEl);
    if (dots) wrap.appendChild(dots);
    return wrap;
  }

  function initCarousel(box) {
    var imgs = kids(box, ':scope > img');
    if (!imgs.length) { box.classList.add('cp-ready'); return; }
    box.innerHTML = '';
    box.appendChild(buildCarousel(imgs, { fade: box.getAttribute('data-mode') === 'fade' }));
    box.classList.add('cp-ready');
  }

  /* ----- Full-screen lightbox shared across pickers ----- */
  var _lb = null, _lbImg = null, _lbBack = null, _lbChrome = null;
  function _setChrome(v) {
    if (_lbBack) _lbBack.style.opacity = v;
    if (_lbChrome) _lbChrome.forEach(function (e) { e.style.opacity = v; });
  }
  function _closeLb() {
    if (!_lb) return;
    _lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    _setChrome('');
    if (_lbImg) { _lbImg.style.transition = ''; _lbImg.style.transform = ''; _lbImg.style.transformOrigin = ''; }
  }
  function openLightbox(srcs, labels, idx, fromEl) {
    if (!_lb) {
      _lb = el('div', 'cp-lb');
      _lb.innerHTML = '<div class="cp-lb__backdrop"></div>' +
        '<button class="cp-lb__close" aria-label="Close">&times;</button>' +
        '<div class="cp-lb__inner"><img class="cp-lb__img" alt=""><div class="cp-lb__btns"></div></div>';
      document.body.appendChild(_lb);
      _lb.addEventListener('click', function (e) {
        if (e.target === _lb || e.target === _lbBack || e.target.classList.contains('cp-lb__close')) _closeLb();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') _closeLb(); });
      _lbImg = _lb.querySelector('.cp-lb__img');
      _lbBack = _lb.querySelector('.cp-lb__backdrop');
      _lbChrome = [_lb.querySelector('.cp-lb__close'), _lb.querySelector('.cp-lb__btns')];
    }
    var img = _lbImg, bw = _lb.querySelector('.cp-lb__btns');
    function show(i) {
      img.src = srcs[i];
      Array.prototype.forEach.call(bw.children, function (b, bi) { b.classList.toggle('is-active', bi === i); });
    }
    bw.innerHTML = '';
    srcs.forEach(function (s, i) {
      var b = el('button', 'cp-lb__btn', labels[i] || String(i + 1));
      b.addEventListener('click', function (e) { e.stopPropagation(); show(i); });
      bw.appendChild(b);
    });
    show(idx);
    _lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';

    // Image grows (at full opacity) from the clicked thumbnail; ONLY the backdrop dims in as it grows.
    if (fromEl) {
      var first = fromEl.getBoundingClientRect();
      var animate = function () {
        img.style.transition = 'none';
        img.style.transform = 'none';
        var last = img.getBoundingClientRect();
        if (!last.width || !last.height) { _setChrome('1'); return; }
        var dx = first.left - last.left, dy = first.top - last.top;
        var sx = first.width / last.width, sy = first.height / last.height;
        img.style.transformOrigin = 'top left';
        img.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
        _setChrome('0');
        requestAnimationFrame(function () {
          img.style.transition = 'transform .36s cubic-bezier(.2,.7,.3,1)';
          img.style.transform = 'none';
          _setChrome('1');   // backdrop + buttons fade in (CSS handles the transition timing)
        });
      };
      if (img.complete && img.naturalWidth) animate();
      else img.onload = animate;
    } else {
      _setChrome('1');
    }
  }

  /* ----- Picker: image stage + labeled buttons. layout 'bottom' or 'right'.
           opts.lightbox = clicking the image opens a full-screen view with the buttons. ----- */
  function buildPicker(imgs, labels, layout, opts) {
    opts = opts || {};
    var wrap = el('div', 'cp-pick cp-pick--' + (layout || 'right'));
    var stage = el('div', 'cp-pick__stage');
    var btns = el('div', 'cp-pick__btns');
    var imgEls = [], btnEls = [];
    var current = 0;
    function select(i) {
      current = i;
      btnEls.forEach(function (x, xi) { x.classList.toggle('is-active', xi === i); });
      imgEls.forEach(function (x, xi) { x.style.display = xi === i ? 'block' : 'none'; });
    }
    imgs.forEach(function (im, idx) {
      im.loading = 'eager';
      im.style.display = idx === 0 ? 'block' : 'none';
      stage.appendChild(im);
      imgEls.push(im);
      var b = el('button', 'cp-pick__btn' + (idx === 0 ? ' is-active' : ''), labels[idx] || String(idx + 1));
      b.addEventListener('click', function () { select(idx); });
      btns.appendChild(b);
      btnEls.push(b);
    });
    if (opts.lightbox) {
      stage.classList.add('cp-pick__stage--zoom');
      stage.addEventListener('click', function () {
        var srcs = opts.lbSrcs || imgs.map(function (im) { return im.currentSrc || im.src; });
        var lbls = opts.lbLabels || labels;
        var start = (opts.lbOffset || 0) + current;
        openLightbox(srcs, lbls, start, imgEls[current]);
      });
    }
    wrap.appendChild(stage);
    wrap.appendChild(btns);
    return wrap;
  }

  function initDualCarousel(box) {
    var cols = kids(box, ':scope > div');
    if (!cols.length) { box.classList.add('cp-ready'); return; }
    // Combined set of ALL images across both galleries, so the lightbox can page through all of them
    var allSrcs = [], allLabels = [];
    cols.forEach(function (col) {
      kids(col, 'img').forEach(function (im) {
        allSrcs.push(im.currentSrc || im.src);
        allLabels.push(im.getAttribute('data-caption') || im.getAttribute('alt') || '');
      });
    });
    var wrap = el('div', 'cp-dc');
    var offset = 0;
    cols.forEach(function (col) {
      var imgs = kids(col, 'img');
      var labels = imgs.map(function (im) { return im.getAttribute('data-caption') || im.getAttribute('alt') || ''; });
      var colEl = el('div', 'cp-dc__col');
      var title = col.getAttribute('data-title');
      if (title) colEl.appendChild(el('div', 'cp-dc__title', title));
      colEl.appendChild(buildPicker(imgs, labels, 'bottom', { lightbox: true, lbSrcs: allSrcs, lbLabels: allLabels, lbOffset: offset }));
      wrap.appendChild(colEl);
      offset += imgs.length;
    });
    box.innerHTML = '';
    box.appendChild(wrap);
    box.classList.add('cp-ready');
  }

  /* ----- Hover-fade: stacked image layers (each with a CSS yellow box + word
           overlay) that crossfade as you hover the left / right zone ----- */
  function initHoverFade(box) {
    var figs = kids(box, ':scope > figure');
    if (figs.length < 2) { box.classList.add('cp-ready'); return; }
    var stage = el('div', 'cp-hf');
    var layers = figs.map(function (fig, idx) {
      var layer = el('figure', 'cp-hf__layer');
      var img = fig.querySelector('img');
      if (img) { img.loading = 'eager'; layer.appendChild(img); }
      var bd = fig.getAttribute('data-box');
      if (bd) {
        var p = bd.split(',');
        var bx = el('span', 'cp-hf__box');
        bx.style.left = p[0] + '%'; bx.style.top = p[1] + '%';
        bx.style.width = p[2] + '%'; bx.style.height = p[3] + '%';
        layer.appendChild(bx);
      }
      var word = fig.getAttribute('data-word');
      if (word) {
        var wd = el('span', 'cp-hf__word', word);
        var ws = fig.getAttribute('data-word-style');
        if (ws) wd.style.cssText += ws;
        layer.appendChild(wd);
      }
      layer.style.opacity = idx === 0 ? '1' : '0';
      layer.style.zIndex = idx === 0 ? '2' : '1';
      stage.appendChild(layer);
      return layer;
    });
    var cur = 0;
    function go(t) {
      if (t === cur) return;
      var prev = layers[cur], n = layers[t];
      layers.forEach(function (l, k) {
        if (k !== t && k !== cur) { l.style.opacity = '0'; l.style.zIndex = '0'; }
      });
      prev.style.opacity = '1'; prev.style.zIndex = '1';
      n.style.transition = 'none';
      n.style.opacity = '0';
      n.style.zIndex = '2';
      void n.offsetWidth;
      n.style.transition = '';
      n.style.opacity = '1';
      cur = t;
    }
    var zones = el('div', 'cp-hf__zones');
    layers.forEach(function (_, idx) {
      var z = el('div', 'cp-hf__zone');
      z.addEventListener('mouseenter', function () { go(idx); });
      z.addEventListener('click', function () { go(idx); });
      zones.appendChild(z);
    });
    stage.appendChild(zones);
    box.innerHTML = '';
    box.appendChild(stage);
    box.classList.add('cp-ready');
  }

  /* ----- Split: text on one side, media (fade carousel) on the other ----- */
  function initSplit(box) {
    var text = box.querySelector('[data-text]');
    var media = box.querySelector('[data-media]');
    if (!media) { box.classList.add('cp-ready'); return; }
    var imgs = kids(media, 'img');
    if (!imgs.length) { box.classList.add('cp-ready'); return; }
    var side = box.getAttribute('data-media-side') || 'right';
    var wrap = el('div', 'cp-split');
    var textCol = el('div', 'cp-split__text');
    if (text) textCol.innerHTML = text.innerHTML;
    var mediaCol = el('div', 'cp-split__media');
    mediaCol.appendChild(buildCarousel(imgs, { fade: true }));
    if (side === 'left') wrap.classList.add('cp-split--mleft');
    wrap.appendChild(mediaCol);   // floated element first so text wraps around it
    wrap.appendChild(textCol);
    box.innerHTML = '';
    box.appendChild(wrap);
    box.classList.add('cp-ready');
  }

  /* ----- Tabs: labeled buttons left, image right. display-based (no layout shift) ----- */
  function initTabs(box) {
    var figs = kids(box, ':scope > figure');
    if (!figs.length) { box.classList.add('cp-ready'); return; }
    var wrap = el('div', 'cp-tabs');
    var btns = el('div', 'cp-tabs__btns');
    var stage = el('div', 'cp-tabs__stage');
    var imgEls = [], btnEls = [];
    figs.forEach(function (fig, idx) {
      var img = fig.querySelector('img');
      if (!img) return;
      img.style.display = idx === 0 ? 'block' : 'none';
      stage.appendChild(img);
      imgEls.push(img);
      var b = el('button', 'cp-tabs__btn' + (idx === 0 ? ' is-active' : ''),
        fig.getAttribute('data-label') || String(idx + 1));
      b.addEventListener('click', function () {
        btnEls.forEach(function (x, xi) { x.classList.toggle('is-active', xi === idx); });
        imgEls.forEach(function (im, ii) { im.style.display = ii === idx ? 'block' : 'none'; });
      });
      btns.appendChild(b);
      btnEls.push(b);
    });
    wrap.appendChild(btns);
    wrap.appendChild(stage);
    box.innerHTML = '';
    box.appendChild(wrap);
    box.classList.add('cp-ready');
  }

  /* ----- Selector: image on top, a row of labeled buttons below ----- */
  function initSelector(box) {
    var figs = kids(box, ':scope > figure');
    if (!figs.length) { box.classList.add('cp-ready'); return; }
    var imgs = [], labels = [];
    figs.forEach(function (fig) {
      var im = fig.querySelector('img');
      if (im) { imgs.push(im); labels.push(fig.getAttribute('data-label') || ''); }
    });
    if (!imgs.length) { box.classList.add('cp-ready'); return; }
    box.innerHTML = '';
    box.appendChild(buildPicker(imgs, labels, box.getAttribute('data-buttons') || 'right'));
    box.classList.add('cp-ready');
  }

  /* ----- Toggle: image (with On/Off) left, text right. display-based ----- */
  function initToggle(box) {
    var media = box.querySelector('[data-media]');
    var text = box.querySelector('[data-text]');
    if (!media) { box.classList.add('cp-ready'); return; }
    var imgs = kids(media, 'img');
    if (!imgs.length) { box.classList.add('cp-ready'); return; }
    var wrap = el('div', 'cp-tg');
    var mediaCol = el('div', 'cp-tg__media');
    var stage = el('div', 'cp-tg__stage');
    imgs.forEach(function (im, idx) { im.style.display = idx === 0 ? 'block' : 'none'; stage.appendChild(im); });
    mediaCol.appendChild(stage);
    var toggle = el('div', 'cp-tg__toggle');
    var btnEls = imgs.map(function (im, idx) {
      var b = el('button', 'cp-tg__btn' + (idx === 0 ? ' is-active' : ''),
        im.getAttribute('data-label') || (idx === 0 ? 'Off' : 'On'));
      b.addEventListener('click', function () {
        btnEls.forEach(function (x, xi) { x.classList.toggle('is-active', xi === idx); });
        imgs.forEach(function (x, xi) { x.style.display = xi === idx ? 'block' : 'none'; });
      });
      toggle.appendChild(b);
      return b;
    });
    mediaCol.appendChild(toggle);
    wrap.appendChild(mediaCol);
    if (text) {
      var textCol = el('div', 'cp-tg__text');
      textCol.innerHTML = text.innerHTML;
      wrap.appendChild(textCol);
    }
    box.innerHTML = '';
    box.appendChild(wrap);
    box.classList.add('cp-ready');
  }

  /* ----- Compare: drag a handle across two stacked images (first = left, second = right) ----- */
  function initCompare(box) {
    var imgs = kids(box, ':scope > img');
    if (imgs.length < 2) { box.classList.add('cp-ready'); return; }
    var wrap = el('div', 'cp-cmp');
    var base = imgs[0], top = imgs[1];
    base.className = 'cp-cmp__base';
    var topWrap = el('div', 'cp-cmp__top');
    topWrap.appendChild(top);
    var line = el('div', 'cp-cmp__line');
    var knob = el('button', 'cp-cmp__knob', '‹›');
    knob.setAttribute('aria-label', 'Drag to compare');
    line.appendChild(knob);
    wrap.appendChild(base);
    wrap.appendChild(topWrap);
    wrap.appendChild(line);
    [[base, 'cp-cmp__label--left'], [top, 'cp-cmp__label--right']].forEach(function (p) {
      var t = p[0].getAttribute('data-label');
      if (t) wrap.appendChild(el('span', 'cp-cmp__label ' + p[1], t));
    });
    var pos = 50;
    function set(p) {
      pos = Math.max(0, Math.min(100, p));
      topWrap.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
      line.style.left = pos + '%';
    }
    function fromEvent(e) {
      var r = wrap.getBoundingClientRect();
      set((e.clientX - r.left) / r.width * 100);
    }
    var dragging = false;
    wrap.addEventListener('pointerdown', function (e) {
      dragging = true; wrap.setPointerCapture(e.pointerId); fromEvent(e);
    });
    wrap.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    wrap.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('pointercancel', function () { dragging = false; });
    knob.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { set(pos - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(pos + 5); e.preventDefault(); }
    });
    set(parseFloat(box.getAttribute('data-start')) || 50);
    box.innerHTML = '';
    box.appendChild(wrap);
    box.classList.add('cp-ready');
  }

  var initers = {
    'compare': initCompare,
    'crossfade': initCrossfade,
    'hoverfade': initHoverFade,
    'carousel': initCarousel,
    'dual-carousel': initDualCarousel,
    'split': initSplit,
    'selector': initSelector,
    'tabs': initTabs,
    'toggle': initToggle
  };

  function run() {
    document.querySelectorAll('.cp-embed[data-widget]').forEach(function (box) {
      if (box.dataset.cpInited === '1') return;
      box.dataset.cpInited = '1';
      var fn = initers[box.getAttribute('data-widget')];
      if (fn) { try { fn(box); } catch (e) { box.classList.add('cp-ready'); } }
    });
    rowFloats();
  }

  /* A floated image and the text after it (up to the next heading or widget) become one
     flex row, so the text sits vertically centered beside the image (Owen 2026-10-12). */
  function rowFloats() {
    document.querySelectorAll('.cp-embed--floatright, .cp-embed--floatleft').forEach(function (box) {
      if (box.parentNode.classList && box.parentNode.classList.contains('cp-frow')) return;
      var text = [], n = box.nextElementSibling;
      while (n && !/^H[1-6]$/.test(n.tagName) && !n.classList.contains('cp-embed')) { text.push(n); n = n.nextElementSibling; }
      if (!text.length) return;
      var row = el('div', 'cp-frow' + (box.classList.contains('cp-embed--floatleft') ? ' cp-frow--left' : ''));
      var col = el('div', 'cp-frow__text');
      box.parentNode.insertBefore(row, box);
      row.appendChild(box);
      text.forEach(function (t) { col.appendChild(t); });
      row.appendChild(col);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
